import {mergeDeepLeft, path} from 'ramda';

// Given a list of keys and a value, construct a deep tree
// ex: (['a', 'b', 'c'], 3) => { a: { b: { c: 3 } } }
export function treeify(keys: string[], val: any): object {
  const [headKey, ...restKeys] = keys;
  return headKey ? {[headKey]: treeify(restKeys, val)} : val;
}

// Given a list of paths and a full object, pick out the values
// for the given paths
export function pickPaths(paths: string[][], state: object): object {
  const pieces = paths.map((keys) => treeify(keys, path(keys, state)));
  return pieces.reduce(mergeDeepLeft, {});
}
